<!--
  -  Copyright (c) Qwoach LLC 2023. All rights reserved.
  -  Unauthorized copying of this file, via any medium is strictly prohibited
  -  Proprietary and confidential
  -  Created by Artem Bogush <artem@qwoach.com> on 18/8/2023
  -->

<template>
	<div>
		<div>{{ legalDocTemplate.name }}</div>
		<div v-if="legalDocTemplate.createdByName">
			<small class="text-muted">Created by {{ legalDocTemplate.createdByName }}</small>
		</div>
		<div v-if="legalDocTemplate.getWorkflowTitle()">
			<small class="text-success">{{ legalDocTemplate.getWorkflowTitle() }}</small>
			<small class="text-muted">
				<ToolTipView>
					This is a standard legal document which is a part of the {{legalDocTemplate.getWorkflowTitle()}}
				</ToolTipView>
			</small>
		</div>

	</div>
</template>

<script>
import BaseComponent from "@/core/components/BaseComponent.vue";
import DocSignTemplateItem from "@/core/modules/DocSign/data/DocSignTemplateItem.js";
import ToolTipView from "@/core/components/Form/Base/ToolTipView.vue";

export default {
	name: "LegalDocTemplateRow",
	components: {ToolTipView},
	extends: BaseComponent,

	props: {
		legalDocTemplate: {DocSignTemplateItem, required: true},
	},
}
</script>

<style lang="scss">

</style>
